import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import sidebarDE from './locales/de/sidebar.json';
import sidebarEN from './locales/en/sidebar.json';
import dashboardDE from './locales/de/dashboard.json';
import dashboardEN from './locales/en/dashboard.json';
import dashboardES from './locales/es/dashboard.json';

const resources = {
  de: {
    sidebar: sidebarDE,
    dashboard: dashboardDE
  },
  en: {
    sidebar: sidebarEN,
    dashboard: dashboardEN
  },
  es: {
    dashboard: dashboardES
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    debug: false,
    
    interpolation: {
      escapeValue: false
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;

